import { LoadingButton } from '@mui/lab';
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../../components/Transition';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (key: string, value: any) => void;
  isSubmitting: boolean;
  resetForm: () => void;
}

const TokenFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  values,
  isSubmitting,
  setFieldValue,
  handleSubmit,
  resetForm,
}) => {
  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        onClose();
      }}
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>New Token</DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={6}
            >
              <FormControl fullWidth>
                <InputLabel id='env-label'>Env</InputLabel>
                <Select
                  labelId='env-label'
                  label='Env'
                  value={values.env}
                  onChange={(e) => setFieldValue('env', e.target.value)}
                >
                  <MenuItem value='test'>test</MenuItem>
                  <MenuItem value='live'>live</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <FormControl fullWidth>
                <InputLabel id='preset-label'>Scopes</InputLabel>
                <Select
                  labelId='preset-label'
                  label='Scopes'
                  value={values.preset}
                  onChange={(e) => setFieldValue('preset', e.target.value)}
                >
                  <MenuItem value='full'>Full agent</MenuItem>
                  <MenuItem value='chat'>Chat agent</MenuItem>
                  <MenuItem value='catalog'>Catalog only</MenuItem>
                  <MenuItem value='read'>Read only</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              onClose();
            }}
          >
            Cancel
          </Button>
          <LoadingButton
            type='submit'
            variant='contained'
            loading={isSubmitting}
          >
            Create
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TokenFormModal;
